import { useSprintQuery } from "sprint-common-web";

import { mapToNoteItem } from "../../api/master-api/notes/GetNotesByAssetsResponse";
import { useNotesApi } from "../../api/master-api/notes/useNotesApi";
import { NoteItem } from "../../components/notes/hooks/state/NoteItem";
import { GetNotesByAsset } from "../../components/notes/hooks/state/NoteSource";
import { sortNotesDescending } from "../../components/notes/hooks/useNotesActions";
import { NotesQueryKey } from "./NotesQueryKey";

export const useGetNotesByAssets = ({ assets }: { assets: GetNotesByAsset[] }) => {
    const { getNotesByAssets } = useNotesApi();

    return useSprintQuery<NoteItem[]>({
        queryKey: [NotesQueryKey.NotesByAssets, assets.map((asset) => asset.id).join(",")],
        queryFn: async (): Promise<NoteItem[]> => {
            if (!assets.length) {
                return [];
            }

            const response = await getNotesByAssets({ assets });

            const notes = Object.entries(response)
                .map(([key, values]) => values.map((item) => mapToNoteItem(item, key)))
                .flat();

            return sortNotesDescending(notes);
        }
    });
};
